export const offeringFeatures = {
  search: true,
  filters: true,
  export: true,
  bulkActions: true,
  columnResizing: true,
  columnVisibility: true,
  savedViews: true,
  infiniteScroll: true,
  multiColumnSort: true,
  calendarView: true,
};
